module.exports = __webpack_public_path__ + "img/mb-nav-ico.783d1043.png";